import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare var $:any
if (environment.production) {
  enableProdMode();
}
else{
  $('.checkQA').removeClass("hide");
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
